import { Box, Stack, Text } from '@mantine/core'
import { modals } from '@mantine/modals'
import { IconAlertTriangle } from '@tabler/icons-react'

import * as classes from '@/styles/ContentModuleFormScreen.css'

interface LiveModuleBannerProps {
  message?: string
}

export function LiveModuleBanner({ message = 'This module is published.' }: LiveModuleBannerProps) {
  return (
    <Box className={classes.liveBanner}>
      <IconAlertTriangle size={20} stroke={1.5} className={classes.liveBannerIcon} />
      <Text className={classes.liveBannerText}>{message}</Text>
    </Box>
  )
}

export function confirmLiveModuleAction(opts: { body: string; confirmLabel?: string }): Promise<boolean> {
  return new Promise(resolve => {
    modals.openConfirmModal({
      centered: true,
      withCloseButton: false,
      children: (
        <Stack gap="md">
          <LiveModuleBanner />
          <Text size="sm">{opts.body}</Text>
        </Stack>
      ),
      labels: { confirm: opts.confirmLabel ?? 'Continue', cancel: 'Cancel' },
      groupProps: { mt: 'xl' },
      onConfirm: () => resolve(true),
      onCancel: () => resolve(false),
      onClose: () => resolve(false),
    })
  })
}
